import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Header from '../../components/Header/';
import Footer from '../../components/Footer/';
import Dashboard from '../../views/Dashboard/';
import EditUser from '../../views/EditUser/EditUser';

class Full extends Component {
    render() {
        return (
            <div className="app">
                <Header />
                <div className="app-body">
                    <main className="main">
                        <div className="container-fluid">
                            <br/>
                            <br/>
                            <Switch>
                                <Route exact path="/admin/users/admins" component={Dashboard}/>
                                <Route path="/admin/users/:id" component={EditUser}/>
                                <Route path="/admin/users" component={Dashboard}/>
                                <Route path="/admin/devices" component={Dashboard}/>
                                <Route path="/admin/areas" component={Dashboard}/>
                                <Redirect from="/admin" to="/admin/users"/>
                            </Switch>
                        </div>
                    </main>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js